module.exports = __webpack_public_path__ + "fonts/display-thin.26d7022c.woff";